<template>
  <div>
    <span>{{date}}</span>
  </div>
</template>

<script>

    import VsSelect from "../_framework/VsSelect";
    import BaseService from "../_framework/api/BaseService.js";
    import EventBus from "../bus.js";
    import axios from "axios";
    import Moment from "moment-jalali";

    export default {
        name: 'miladi-to-shamsi',
        props: ['data'],
        components: {
            VsSelect
        },
        data() {
            return {
               date: ""
            }
        },
        mounted() {
            let date = Moment(this.data,"YYYY/MM/DD"  );
            this.date = date.format("jYYYY/jMM/jDD");
        }
    }

</script>

<style scoped lang="scss">

</style>
